import React, { useState, useContext } from 'react'
import Icon from '@material-ui/core/Icon'
import HighLowTable from './highlow-table/highlow-table.js'
import Timeline from './timeline-table'
import MacroGraph from './average-graph/macro-graph'
import MacroData from './average-graph/macro-data'
import WeightGraph from './weight-graph'
import ProfileCard from './profile-card'
import SettingsCard from './settings-card'
import '../../../../../css/inspect.sass'
import '../../../../../css/profile.sass'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeContext } from 'styled-components'
import RecentCheckins from './recent-check-ins'

const useStyles = makeStyles(theme => ({
  buttonProgress: {
    color: '#2dd042',
  },
}));

const Profile = (props) => {
  const theme = useContext(ThemeContext)
  const [ascendingOrder, updateAscendingOrder] = useState(true)
  const account = props.account
  const macroData = props.macroData
  const classes = useStyles();

  const getLatestWeightDifference = () => {
    let difference = 0
    let newArray = []
    for(let i = account.timeline.length-1; i >= 0; i--) {
      if(account.timeline[i].body_fat !== null) {
        newArray.push(account.timeline[i].weight)
      }
    }
    
    if(newArray.length < 2)
      difference = 0
    else {
      difference = ((newArray[0]*2.20462) - (newArray[1]*2.20462)).toFixed(1)
    }

    return difference
  }
  
  const getLatestBFDifference = () => {
    let difference = 0
    let newArray = []
    for(let i = account.timeline.length-1; i >= 0; i--) {
      if(account.timeline[i].body_fat !== undefined) {
        newArray.push(account.timeline[i].body_fat)
      }
    }
    
    if(newArray.length < 2)
      difference = 0
    else {
      let lastTwo = newArray.slice(0, 2)
      difference = (lastTwo[0] - lastTwo[1]).toFixed(1)
    }
    return difference
  }

  const hasTracked = (avgProtein, avgCarbs, avgFat) => {
    if(avgProtein === 0 && avgCarbs === 0 && avgFat === 0) {
      return <p style={{ color: '#ff649f', fontSize: '1.25rem', fontStyle: 'bold', textAlign: 'center', padding: '20px 0px'}}>User hasn't tracked any food this check-in period</p>
    }
    else return null
  }
  const relatedWeighInDateString = props.relatedWeighInDateString

  const selectGraphDate = props.selectGraphDate
  const trackerData = props.trackerData

  let earliestWeighInDateString = null
    for(let key in macroData.weighInDetails) {
      if(earliestWeighInDateString === null || key < earliestWeighInDateString) {
        earliestWeighInDateString = key
    }
  }

  let latestWeighInDateString = null
    for(let key in macroData.weighInDetails) {
      if(latestWeighInDateString === null || key > latestWeighInDateString) {
        latestWeighInDateString = key
    }
  }

  const checkins = macroData.weighInDetails
  const checkinDates = Object.keys(macroData.weighInDetails)

  const getLastCheckinDate = (date) => {
    for(let i = 0; i <= checkinDates.length - 1; i++) {
      if(date === checkinDates[i]) {
        return checkinDates[i+1]
      }
    }
  }

  const getNextCheckinDate = (date) => {
    for(let i = checkinDates.length; i => 0; i--) {
      if(date === checkinDates[i]) {
        return checkinDates[i-1]
      }
    }
  }

  const getDateString = (date) => {
    if(trackerData.selectedGraphDate < latestWeighInDateString) 
      return moment.utc(relatedWeighInDateString).format('MMM DD') + ' - ' + moment.utc(getNextCheckinDate(date)).subtract(1, "days").format('ll')
    else
      return moment.utc(relatedWeighInDateString).format('ll') + ' - CURRENT'
  }

  const renderAverageIntake = (relatedDate) => {
    if(props.loadingTrackerData) {
      return (
        <div className="avn-widget">
          <div className="avn-widget-loading">
            <CircularProgress className={classes.buttonProgress} size={64}/>
            <h3>Loading data...</h3>
          </div>
        </div>
      )
    } else {
      for (var date in checkins) {
        if (checkins.hasOwnProperty(date) && date === relatedDate) {
          let currentDate = checkins[date].result
          let averageCalories = (Math.round(currentDate.avgProtein) + Math.round(currentDate.avgCarbs)) * 4 + Math.round(currentDate.avgFat) * 9
          let averageCaloriesTarget = (currentDate.avgTargetProtein + currentDate.avgTargetCarbs) * 4 + currentDate.avgTargetFat * 9
  
          return (
            <div className="avn-widget" key={date}>
              {hasTracked(currentDate.avgProtein,currentDate.avgCarbs,currentDate.avgFat) ? 
                hasTracked(currentDate.avgProtein,currentDate.avgCarbs,currentDate.avgFat)
              :  
                <>
                  <MacroGraph
                    proteinConsumed={Math.round(currentDate.avgProtein)}
                    carbsConsumed={Math.round(currentDate.avgCarbs)}
                    fatConsumed={Math.round(currentDate.avgFat)}
                    proteinTarget={Math.round(currentDate.avgTargetProtein)}
                    carbsTarget={Math.round(currentDate.avgTargetCarbs)}
                    fatTarget={Math.round(currentDate.avgTargetFat)}
                    vacationMode={account.user.vacation_mode}
                    showConsumedMacros={trackerData.showConsumedMacros}
                    setShowConsumedMacros={props.setShowConsumedMacros}
                  />
                  <MacroData
                    avgCalories={averageCalories}
                    avgCaloriesTarget={averageCaloriesTarget}
                    avgFiber={currentDate.avgFiber}
                    vacationMode={account.user.vacation_mode}
                    showWeeklyAvg={true}
                    macroData={props.macroData}
                    updateShowWeeklyAvg={() => console.log("hide")}
                    trackerData={trackerData}
                    relatedWeighInDateString={props.relatedWeighInDateString}
                  />
                </>
              }
              
              {/* <BarGraph targetProtein={currentDate.avgTargetProtein.toFixed()} targetCarbs={currentDate.avgTargetCarbs.toFixed()} targetFat={currentDate.avgTargetFat.toFixed()} targetCalories={calories} targetFiber={currentDate.fiber} avgProtein={currentDate.avgProtein} avgCarbs={currentDate.avgCarbs} avgFat={currentDate.avgFat} avgFiber={currentDate.avgFiber}/> */}
              <div className="arrow-container">
                {relatedWeighInDateString !== earliestWeighInDateString && (
                  <button
                    color="primary"
                    onClick={() => {
                      if ((trackerData.selectedGraphDate > earliestWeighInDateString) && (trackerData.selectedGraphDate > earliestWeighInDateString)) {
                        selectGraphDate(getLastCheckinDate(date));
                      }
                    }}
                  >
                    <Icon>arrow_back_ios</Icon>
                  </button>
                )}
                <h5 className="timeline-date-text" style={{ color: "#FFF" }}>
                  {getDateString(date)}
                </h5>
  
                <button
                  color="primary"
                  onClick={() => {
                    if (trackerData.selectedGraphDate < latestWeighInDateString) {
                      selectGraphDate(getNextCheckinDate(date));
                    }
                  }}
                >
                  {trackerData.selectedGraphDate < latestWeighInDateString && (
                    <Icon>arrow_forward_ios</Icon>
                  )}
                </button>
              </div>
            </div>
          );
        }
      }
    }
  }

  const getGoalLevel = () => {
    const LBS_PER_KG = 2.204622
    const goal = account.user.goal
    const targetWeight = account.user.target_weight
    const goal_weight_delta = account.user.goal_weight_delta
    const goal_min_weekly_calorie_increase = account.user.goal_min_weekly_calorie_increase

    if(!goal) // NOTE: Required when getUserFetch is not completed
      return

    if(goal === 'MAINTENANCE') {
      return ((targetWeight - goal_weight_delta) * LBS_PER_KG).toFixed(1) + ' - ' + ((targetWeight + goal_weight_delta) * LBS_PER_KG).toFixed(1) + ' lbs'
    } else if(goal === 'REVERSE DIETING') {
      return goal_min_weekly_calorie_increase + ' - ' + (goal_min_weekly_calorie_increase + 15) + ' kCal/week'
    } else {
      return (goal_weight_delta * LBS_PER_KG).toFixed(2) + ' lbs/week'
    }
  }

  // const lastCheckin = moment.utc(getLastCheckinDate()).format('ll') 
  const prevDate = moment.utc(account.user.lastWeighInDate).format('YYYY-MM-DD')
  return (
    <div className='inspect-page-container inspect'>
      <div className='container'>
        <div className='graph-card' style={{paddingTop: 0}}>
          <h2>Profile</h2>
          <ProfileCard 
            profilePic={account.user.profilePic ? account.user.profilePic : ''}
            name={account.user.full_name}
            email={account.user.email_address}
            currentWeight={`${Number(account.user.weight * 2.20462).toFixed(1)} lbs ${(account.user.daily_weigh_in_enabled === 1) ? '(average)' : ''}`}
            goal={account.user.goal}
            goalText={theme.goal[account.user.goal]}
            goalLevel={getGoalLevel()}
            weightDifference={getLatestWeightDifference()}
            bodyfatDifference={`${getLatestBFDifference()}%`}
            checkinPeriod={`${moment.utc(getLastCheckinDate(prevDate)).format('MMM DD')} - ${moment.utc(account.user.lastWeighInDate).format('ll')}`}
            account={account}
            macroData={macroData}
          />
        </div>
      </div>
      
      <div className='container'>
        <div className='graph-card'>
          <h2>Recent Check-ins</h2>
          <div className='table-container'>
            <RecentCheckins recent accountId={props.accountId} account={account} ascendingOrder={ascendingOrder} macroData={macroData} getMacroData={props.getMacroData} />
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='graph-card'>
          <h2>Average Macro Intake</h2>
          {renderAverageIntake(relatedWeighInDateString)}
        </div>
      </div>
      {account.user.high_low_macros &&
        <div className='container'>
          <div className='graph-card'>
            <HighLowTable account={account} />
          </div>
        </div>
      }
      <div className='container'>
        <div className='graph-card'>
          <h2>Progress</h2>
          <WeightGraph weighins={account.user.weighins} useMetric={account.user.use_metric_units} macros={account.timeline}/>
        </div>
      </div>
      <div className='container'>
        <div className='graph-card'>
          <h2>Account Info</h2>
          <SettingsCard 
            account={account}
            macroData={macroData}
          />
        </div>
      </div>
    </div>
  )
}

export default Profile